import type React from 'react';

import { Image } from '@change/ds-core-ui';

import type { SocialPostPlatformId } from '../../../../hooks/useSocialPostUrlForm/platforms';
import { SourceIcon } from '../../../SourceIcon';

const IconTile: React.FC<{ platform: SocialPostPlatformId }> = ({ platform }) => (
	<div
		data-qa="social-post-chip-thumbnail-fallback"
		className="bg-fill-weaker flex aspect-4/3 h-full w-full items-center justify-center rounded-sm"
	>
		<SourceIcon platform={platform} size="medium" className="text-icon-weak" />
	</div>
);

/**
 * The preview image, or a neutral icon tile when there is none or it fails to load. Decorative: the
 * chip is a button whose `aria-label` names it, and the source line repeats the label visibly.
 */
export const ChipThumbnail: React.FC<Props> = ({ image, platform }) => (
	<div className="h-full w-26 shrink-0 py-2">
		{image ? (
			<Image
				aspectRatio="4:3"
				src={image}
				alt=""
				className="h-full w-full rounded-sm object-cover"
				fallback={<IconTile platform={platform} />}
			/>
		) : (
			<IconTile platform={platform} />
		)}
	</div>
);

type Props = Readonly<{
	image: string | undefined;
	platform: SocialPostPlatformId;
}>;
